export default __webpack_public_path__ + "10c6852051e401e61ba3a3d0c123aa57.svg";